/**
 * Created by mh on 2017/5/23.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import AssetModel from './model/AssetModel';
import { TextToCopy } from './TextToCopy';

const NumberPad = (pad, str, padLeft) => {
    if (typeof str === 'undefined') {
        return pad;
    }
    if (padLeft) {
        return (pad + str).slice(-pad.length);
    }
    return (str + pad).substring(0, pad.length);
};

const MsToSMPTETimeCode = (ms) => {
    const fd = 40;
    const sd = fd * 25; // 25 frames with 40ms
    const md = sd * 60;
    const hd = md * 60;

    const mms = ms % hd;
    const h = (ms - mms) / hd;
    const sms = mms % md;
    const m = (mms - sms) / md;
    const fms = sms % sd;
    const s = (sms - fms) / sd;
    const ffs = fms % fd;
    const f = (fms - ffs) / fd;

    return (
        `${NumberPad('00', h, true)}:${NumberPad('00', m, true)}:` +
        `${NumberPad('00', s, true)}:${NumberPad('00', f, true)}`
    );
};


const groupLine = (segment) => (
    <tr key={`seg-head-{segment.groupKey}-{segment.order}`}>
        <th colSpan={6}>{segment.groupName}</th>
    </tr>
);
const segmentLine = (segment) => {
    const tcIn = MsToSMPTETimeCode(segment.tcInMs);
    const tcOut = MsToSMPTETimeCode(segment.tcOutMs);
    const tcDuration = MsToSMPTETimeCode(segment.durationMs);
    return (
        <tr key={`seg-{segment.groupKey}-{segment.order}`}>
            <td></td>
            <td>{segment.name}</td>
            <td>
                {segment.metadata.CartNo}#{segment.groupKey}
                {segment.order.toString().padStart(2, '0')}
            </td>
            <td>
                <TextToCopy text={tcIn} />
            </td>
            <td>
                <TextToCopy text={tcOut} />
            </td>
            <td>
                <TextToCopy text={tcDuration} />
            </td>
        </tr>
    );
};
const headerLine = () => (
    <tr key={`seg-header`}>
        <th>Group</th>
        <th>Name</th>
        <th>CartNo Id</th>
        <th>TC IN</th>
        <th>TC OUT</th>
        <th>Duration</th>
    </tr>
);
// const tagLine = scene => (
//     <tr>
//         <td>{LabelsToList(scene.labels)}</td>
//         <td />
//         <td />
//         <td />
//         <td />
//     </tr>
// );
const groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

const AssetSegmentRows = (asset) => {
    if (!asset) {
        return null;
    }
    const result = [];
    result.push(headerLine());

    const grouped = groupBy(asset.segments, 'groupKey');
    console.log(grouped);
    Object.keys(grouped).map((key) => {
        const segments = grouped[key];
        // Use first segment for header
        result.push(groupLine(segments[0]));
        // Put all segments
        return segments.map((segment) => {
            result.push(segmentLine(segment));
            // result.push(tagLine(segment));
            return result;
        });
    });
    return result;
};

@inject('auth')
@observer
class AssetMediaSegments extends React.Component {
    render() {
        const { asset } = this.props;
        // Only display if any
        if (asset.segments && asset.segments.length > 0) {
            return (
                <section>
                    <h4>Media Segments</h4>
                    <div className="table-responsive">
                        <table className="table table-sm table-striped">
                            <tbody>{AssetSegmentRows(asset)}</tbody>
                        </table>
                    </div>
                </section>
            );
        }
        return null;
    }
}
AssetMediaSegments.propTypes = {
    asset: PropTypes.instanceOf(AssetModel).isRequired,
};

export default injectIntl(AssetMediaSegments);
